module.exports = {

  backgroundLight: "#ffffff",
  background: "#fafafa",
  backgroundDark: "rgb(234,234,234)",

  textDark: "#171717", //neutral-900
  text: "#525252", //neutral-600
  textLight: "#737373", //neutral-500
  textDisabled: "#d4d4d4", //neutral-300

  textInverted: "#F9FAFA",

  primaryDark: "#4f46e5", //indigo-800
  primary: "#4f46e5", //indigo-600
  primaryLight: "#6366f1", //indigo-500
  primaryLighter: "#a5b4fc", //indigo-300

  success: "#009140",
  successBorder: "#75b691",
  successBackground: "#e2ffe3",

  warning: "#ffc021",

  error: "rgb(224, 49, 48)",
  errorBorder: "rgb(213,149,140)",
  errorBackground: "#ffe3e2",
};
